import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["label", "className", "style", "children", "onClick", "disabled", "tootipContent", "tooltipProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Tooltip from '@tekion/tekion-components/src/atoms/tooltip';
import { EMPTY_OBJECT, EMPTY_STRING } from 'tbase/app.constants';
import styles from './ButtonRole.module.scss';
import { isEmpty } from '../../../utils/helper';

// This component just created simple button so that it will be easy to have custom styling.

const ButtonRole = _ref => {
  let {
      label,
      className,
      style,
      children,
      onClick,
      disabled,
      tootipContent,
      tooltipProps
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const onButtonClick = useCallback(event => {
    if (!disabled) onClick(event);
  }, [disabled, onClick]);
  return /*#__PURE__*/React.createElement("div", _extends({}, restProps, {
    role: "button",
    tabIndex: 0,
    className: cx(className, styles.container, {
      [styles.disabled]: disabled
    }),
    style: _objectSpread({}, style),
    onClick: onButtonClick
  }), !isEmpty(tootipContent) ? /*#__PURE__*/React.createElement(Tooltip, _extends({
    title: tootipContent,
    destroyTooltipOnHide: true
  }, tooltipProps), label || children) : /*#__PURE__*/React.createElement(React.Fragment, null, label || children));
};
ButtonRole.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tootipContent: PropTypes.string,
  tooltipProps: PropTypes.object
};
ButtonRole.defaultProps = {
  label: EMPTY_STRING,
  className: EMPTY_STRING,
  style: EMPTY_OBJECT,
  children: EMPTY_STRING,
  disabled: false,
  tootipContent: EMPTY_STRING,
  onClick: () => {},
  tooltipProps: EMPTY_OBJECT
};
export default ButtonRole;